// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const MY_PRODUCT_NO_REVIEW = "Zatia\u013e nehodnotila";
export const MY_PRODUCT_REVIEW_WAITING_FOR_APPROVE = "\u010cak\u00e1 na schv\u00e1lenie";
export const REMOVE_FROM_PROFILE = "Odober z profilu";
export const STROLLER_ADD_REVIEW = "Pridaj hodnotenie";
export const USER_STROLLERS_MY_REVIEW = "Moje hodnotenie";
